<template>
  <div>
    <v-dialog
      v-model.trim="showCreateLeadForm"
      max-width="600"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
        >
          <slot name="activator" />
        </div>
      </template>
      <v-card>
        <v-card-title
          class="pa-0"
        >
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Kontakt anlegen</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="hideDialog"
              >
                <v-icon large>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="dialog-content-overflow">
          <CreateLeadForm
            :lead-data="lead.personalData"
            :purchase-property-data="lead.purchaseProperty"
            :copmany="company"
            @createdLeadResult="handleCreatedResult"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="hideDialog"
          >
            abbrechen
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="submitCreateLeadForm"
          >
            speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CreateLeadForm from './CreateLeadForm.vue'
import bus, { eventNames } from '@/lib/eventBus'
const initialUserState = (company) => ({
  personalData: {
    lastname: null,
    firstname: null,
    email: null,
    phone: null
  },
  purchaseProperty: {
    price: null,
    date: null,
    address: {
      street: null,
      houseNumber: '',
      zip: null,
      city: null,
      countryCode: company?.country?.toLowerCase()
    }
  }
})

export default {
  components: {
    CreateLeadForm
  },
  props: {
    refetchParent: {
      type: Function,
      default: () => {}
    },
    company: {
      type: Object,
      default: () => ({ country: null })
    }
  },
  data () {
    return {
      isValid: false,
      showCreateLeadForm: false,
      lead: initialUserState(this.company)
    }
  },
  methods: {
    resetLeadData () {
      // reset
      bus.$emit(eventNames.RESET_CREATE_LEAD_FORM)
      this.lead = initialUserState(this.company)
    },
    hideDialog () {
      this.showCreateLeadForm = false
      this.resetLeadData()
    },
    submitCreateLeadForm () {
      bus.$emit(eventNames.SUBMIT_CREATE_LEAD_FORM)
    },
    handleCreatedResult ({ createLeadByUser }) {
      bus.$emit(eventNames.SHOW_SNACKBAR, { color: 'success', text: 'Kontakt wurde angelegt' })
      this.$emit('created', createLeadByUser)
      this.refetchParent()
      this.hideDialog()
    }
  }
}
</script>

<style scoped>
.dialog-content-overflow{
  max-height: 500px;
  overflow: scroll
}
</style>
